import { useUserFirmRoleContext } from '../providers/UserFirmRoleProvider';
import { UserRoleEnum } from '../types/user';

type useIsFirmRoleResult = { isUser: boolean; isManager: boolean; isAdmin: boolean; isExternalUser: boolean };

export function useIsFirmRole(): useIsFirmRoleResult {
    const role = useUserFirmRoleContext();

    return {
        isUser: role === UserRoleEnum.USER,
        isManager: role === UserRoleEnum.MANAGER,
        isAdmin: role === UserRoleEnum.ADMIN,
        isExternalUser: role === UserRoleEnum.EXTERNAL_USER,
    };
}
